<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '40vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off" *ngIf="entidadeForm">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-5" *ngIf="entidade.anulacao">
          <lib-page-header page-title="PRÉ-LIQUIDAÇÃO - ANULAÇÃO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/invoice3.png">
          </lib-page-header>
        </div>
        <div class="col-md-5" *ngIf="!entidade.anulacao">
          <lib-page-header page-title="PRÉ-LIQUIDAÇÃO ORÇAMENTÁRIA"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/invoice3.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/pre-liquidacoes']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="entidade.id" (click)="imprimir()" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir nota de pré-liquidação" height="22"
              width="22">
          </button>
          <button *ngIf="entidade.id" data-toggle="modal" data-target="#dialogAnular"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/coins_delete.png" alt="Anular" title="Anular pré-liquidação" height="22"
              width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar pré-liquidação</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="form-row">
        <div class="col-md-8">
          <div class="form-row">
            <div class="col-md-3 p-0">
              <label for="numero_empenho" class="font-weight-bold" style="color: #009688">Empenho Nº:<span
                  class="text-danger">*</span></label>
              <input #numero_empenho [(ngModel)]="empenhoNumero" [ngModelOptions]="{standalone: true}"
                (blur)="atualizarEmpenho()" type="text" class="form-control" id="liq">
            </div>
            <div class="col-md-1 pl-1">
              <label for="parcela" class="font-weight-bold" style="color: #009688">Parcela</label>
              <input readonly formControlName="parcela" type="text" tabindex="-1" class="form-control text-right"
                id="parcela" placeholder="0">
            </div>
            <div class="col-md-3 offset-md-2">
              <label for="data_liquidacao">Data<span class="text-danger">*</span></label>
              <p-calendar id="data_liquidacao" formControlName="data_liquidacao" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="col-md-3" *ngIf="!entidade.anulacao">
              <label for="data_vencimento">Vencimento<span class="text-danger">*</span></label>
              <p-calendar id="data_vencimento" formControlName="data_vencimento" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="col-md-3" *ngIf="entidade.anulacao">
              <label for="data_referencia">Data referência<span class="text-danger">*</span></label>
              <p-calendar id="data_referencia" formControlName="data_referencia" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="row">
            <div class="col-12 mb-0">
              <input style="font-weight: bold" *ngIf="entidade.empenho" tabindex="-1"
                value="{{entidade.empenho.favorecido.cpf_cnpj | CPF}} {{entidade.empenho.favorecido.nome}}" readonly
                type="text" class="form-control-plaintext font-weight-bold" id="favorecido">
              <small *ngIf="entidade.empenho"
                class="form-text text-muted">{{entidade.empenho.favorecido.endereco}}</small>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade.empenho" tabindex="-1"
                value="{{entidade.empenho.subelemento.codigo}} {{entidade.empenho.subelemento.nome}}" readonly
                type="text" class="form-control-plaintext" id="ficha">
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade.empenho" tabindex="-1"
                value="{{entidade.empenho.ficha.programa.codigo}} {{entidade.empenho.ficha.programa.nome}}" readonly
                type="text" class="form-control-plaintext" id="programa">
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade.empenho" tabindex="-1"
                value="{{entidade.empenho.ficha.acao.codigo}} {{entidade.empenho.ficha.acao.nome}}" readonly type="text"
                class="form-control-plaintext" id="acao">
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade.empenho && entidade.empenho.modalidade"
                value="MODALIDADE: {{entidade.empenho.modalidade.codigo}} - {{entidade.empenho.modalidade.nome}}"
                readonly type="text" class="form-control-plaintext" id="modalidade" tabindex="-1">
            </div>
          </div>

          <hr class="mt-3 mb-2" />

          <div class="form-row">
            <div class="col-6">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="documento">Tipo Documento:<span class="text-danger">*</span></label>
                  <select formControlName="tipo_documento" class="form-control form-control-sm">
                    <option [ngValue]="item.id" *ngFor="let item of listaTipoDocumentos">
                      {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label for="documento">Documento:<span class="text-danger">*</span></label>
                  <input id="documento" formControlName="documento" type="text" class="form-control">
                </div>
              
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="documento">Série:<span class="text-danger">*</span></label>
                  <input id="documento" formControlName="serie" type="text" class="form-control">
                </div>
                <div class="form-group col-md-6">
                  <label for="data_emissao">Data emissão<span class="text-danger">*</span></label>
                  <p-calendar id="data_emissao" formControlName="data_emissao" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                    [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-row">
                <div class="form-group offset-6 col-md-6">
                  <label for="valor_liquidado">Valor pré-Liquidado<span class="text-danger">*</span></label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_liquidado" type="text"
                    class="form-control text-right" id="valor_liquidado" placeholder="0,00"
                    style="font-weight: bold; color: #1e88e5" (blur)="verificarParcela()">
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-4">
          <div class="card">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Empenhado <span class="float-right">{{empenhado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item">Pré-Liquidado <span class="float-right">{{liquidado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item">Pago <span class="float-right">{{pago | number:'1.2-2'}}</span>
              </li>
              <li *ngIf="entidade" class="list-group-item font-weight-bold">Saldo a liquidar<span
                  class="float-right font-weight-bold">{{+empenhado + (entidade.id ? +entidade.valor_liquidado : 0) -
                  +liquidado - +entidadeForm.get('valor_liquidado').value | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico<span class="text-danger">*</span></label>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" title="salvar e novo" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<lib-pre-liquidacao-anulacao *ngIf="entidade.id" [login]="login" [empNumero]="entidade.empenho?.numero"
  [idLiquidacao]="entidade.id">
</lib-pre-liquidacao-anulacao>